import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  beforeLoad: ({ context }) => {
    const { isAuthenticated, isLoading } = context.auth

    // Wait for Keycloak to finish initializing before redirecting
    if (isLoading) return

    if (isAuthenticated) {
      throw redirect({
        to: '/home',
      })
    } else {
      throw redirect({
        to: '/login',
      })
    }
  },
  component: RootLoadingPage,
})

function RootLoadingPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-primary border-t-transparent" />
        <p className="text-sm text-muted-foreground">Loading...</p>
      </div>
    </div>
  )
}
